export default {
  application: {
    deployment: '私有部署',
    document: '文档',
    'en-US': 'English',
    github: 'GitHub',
    productTitle: '表单设计器',
    qqGroup: '技术WX群',
    subscription: '订阅mobile',
    'zh-CN': '简体中文',
  },
  designer: {
    advancedFieldTitle: '高级字段',
    basicFieldTitle: '基础字段',
    componentLib: '组件库',
    containerTitle: '容器',
    customFieldTitle: '自定义扩展字段',
    dragAction: '拖动',
    dragHandlerHint: '鼠标拖拽容器组件或字段组件并放置于表单中',
    formLib: '表单模板',

    hint: {
      cancel: '取消',
      cellSetting: '单元格操作',
      chineseValidator: '仅中文字符',
      cloneWidget: '复制组件',
      closePreview: '关闭',
      colspanNotConsistentForDeleteEntireColumn: '存在列宽不一致的单元格, 不可删除整列.',
      colspanNotConsistentForMergeEntireColumn: '存在列宽不一致的单元格, 无法合并整列.',
      confirm: '确定',
      copyField: '复制字段组件',
      copyFormData: '复制JSON',
      copyHtmlCode: '复制HTML代码',
      copyHtmlCodeFail: '复制HTML代码失败',
      copyHtmlCodeSuccess: '复制HTML代码成功',
      copyJson: '复制JSON',

      copyJsonFail: '复制JSON失败',
      copyJsonSuccess: '复制JSON成功',
      copySFCFail: '复制SFC代码失败',
      copySFCSuccess: '复制SFC代码成功',
      copyVue2SFC: '复制Vue2代码',
      copyVue3SFC: '复制Vue3代码',
      copyVueCode: '复制Vue代码',
      copyVueCodeFail: '复制Vue代码失败',
      copyVueCodeSuccess: '复制Vue代码成功',
      currentNodeCannotBeSelected: '当前组件节点不可选择',
      disableForm: '禁用编辑',
      dragHandler: '拖拽手柄',
      duplicateName: '组件名称已存在: ',
      emailValidator: '邮箱',
      enableForm: '恢复编辑',
      exportFormData: '表单数据',
      fileNameForSave: '文件名：',
      fileNameInputPlaceholder: '请输入文件名',
      formSetting: '表单设置',
      getFormData: '获取数据',
      import: '导入',
      importDSHint: '导入的数据源格式须符合规范，以保证顺利导入.',
      importJsonHint: '导入的JSON内容须符合下述格式，以保证顺利导入.',
      importJsonSuccess: '导入JSON成功',
      insertColumn: '插入新列',
      insertRow: '插入新行',
      invalidJsonFormat: '无效的表单JSON格式',
      invalidOptionsData: '无效的选项数据:',
      jsonVersionMismatch: '表单JSON版本号不匹配',
      lastColCannotBeDeleted: '最后一列不可删除.',
      lastPaneCannotBeDeleted: '仅剩一个选项卡页不可删除.',
      lastRowCannotBeDeleted: '最后一行不可删除.',
      letterAndNumberValidator: '数字字母',
      letterValidator: '字母',
      loadFormTemplate: '加载此模板',
      loadFormTemplateFailed: '表单模板加载失败',
      loadFormTemplateHint: '是否加载这个模板？加载后会覆盖设计器当前表单，你可以使用“撤销”功能恢复。',
      loadFormTemplateSuccess: '表单模板加载成功',
      maxTextLengthError: '长度必须小于{maxLength}。',
      minTextLengthError: '长度必须大于{minLength}。',
      mobilePhoneValidator: '手机号码',

      moveDownLastChildHint: '已经移动到最下面',
      moveDownWidget: '下移组件',
      moveUpFirstChildHint: '已经移动到最上面',
      moveUpWidget: '上移组件',

      nameRequired: '组件名称不可为空',
      noChineseValidator: '非中文字符',
      noSelectedWidgetHint: '当前没有选中设置的组件',
      numberValidator: '数字',
      onlyFieldWidgetAcceptable: '子表单只能接收字段组件',
      prompt: '提示',
      remove: '移除组件',
      resetForm: '重置表单',
      rowspanNotConsistentForDeleteEntireRow: '存在行高不一致的单元格, 不可删除整行.',
      rowspanNotConsistentForMergeEntireRow: '存在行高不一致的单元格, 无法合并整行.',

      sampleLoadedFail: '表单示例加载失败',
      sampleLoadedSuccess: '表单示例加载成功',
      saveFileTitle: '保存为文件',
      saveFormData: '保存为文件',
      saveFormJson: '保存为文件',
      saveHtmlCode: '保存Html文件',
      saveVue2SFC: '保存为Vue2组件',
      saveVue3SFC: '保存为Vue3组件',

      saveVueCode: '保存Vue文件',
      searchPlaceholder: '请输入搜索内容',
      selectParentWidget: '选中父组件',
      switchReadMode: '只读查看',
      urlValidator: '网址',
      widgetSetting: '组件设置',
    },

    noWidgetHint: '请从左侧列表中选择一个组件, 然后用鼠标拖动组件放置于此处.',

    setting: {
      // actionColumn: '操作',
      // addOperationButton: '增加按钮',
      // addTableColumn: '增加列',
      // alignTypeOfColumn: '对齐方式',
      // buttonsColumnEdit: '操作按钮编辑',
      // buttonsColumnTitle: '列标题',
      // buttonsColumnWidth: '列宽度（px）',
      // columnLabel: '显示名称',
      // columnName: '字段名称',
      // columnWidth: '列宽(px/%)',
      // customRenderGroup: '动态渲染',
      // data-source
      // data-table
      // deleteOperationButtonHint: '确定删除该按钮？',
      // deleteTableColumn: '删除列',
      // editAction: '编辑...',
      // fixedColumn: '是否固定',
      // formatOfColumn: '格式化',
      // onlyOneColumnCannotBeDeleted: '表格只有一列时不可删除.',
      // operationButtonDisabled: '禁用',
      // operationButtonDuplicatedNameError: '按钮名称不可重复',
      // operationButtonHidden: '隐藏',
      // operationButtonLabel: '文字',
      // operationButtonName: '名称',
      // operationButtonRound: '圆角',
      // operationButtonSize: '大小',
      // operationButtonsSetting: '操作按钮设置',
      // operationButtonType: '类型',
      // renderFunction: '渲染函数',
      // rowSpacing: '行距（px）',
      // showButtonsColumn: '显示操作按钮列',
      // showCheckBox: '是否显示复选框列',
      // showIndex: '是否显示行号',
      // showPagination: '是否显示分页',
      // showSummary: '是否合计',
      // smallPagination: '小型分页',
      // sortableColumn: '是否排序',
      // stripe: '是否斑马线',
      // tableColEdit: '表格列编辑',
      // tableDataEdit: '表格数据编辑',
      // tableHeight: '高度(px/%)',
      // tableWidth: '宽度(px/%)',
      // visibleColumn: '是否显示',
      activeColor: '开启时背景色',
      activeText: '开启时文字描述',
      activeValue: '开启时的值',
      addColumn: '增加栅格',
      addCss: '编写CSS',
      addDataSet: '新增数据集',
      addDataSource: '新增数据源',
      addEventHandler: '编写代码',
      addOption: '增加选项',
      addRequestData: '新增发送数据',
      addRequestHeader: '新增请求头',
      addRequestParam: '新增请求参数',
      addTabPane: '增加选项卡页',
      advancedSetting: '高级属性',
      allowCreate: '允许创建选项',
      allowHalf: '允许半选',
      appendButton: '添加后置按钮',
      appendButtonDisabled: '后置按钮禁用',
      appendButtonIcon: '后置按钮Icon',
      appendButtonLabel: '后置按钮文本',
      appendButtonType: '后置按钮类型',
      attributeSetting: '属性设置',
      automaticDropdown: '自动弹出选项',
      basicSetting: '基本属性',
      blockLayout: '块',
      border: '带有边框',
      buttonIcon: '按钮Icon',
      buttonStyle: '显示为按钮',
      cellHeight: '高度',
      cellWidth: '宽度',
      centerAlign: '居中',
      checkStrictly: '任意级节点可选',
      childrenKeyName: '子节点属性名称',
      circle: '圆形按钮',
      clearExistingDataSource: '导入后清空原有数据源',
      clearRequestResult: '清空结果',
      clearable: '可清除',
      closeButtonDefaultText: '确认',
      closeButtonText: '确认按钮文本',
      colOffsetTitle: '左侧间隔格数',
      colPullTitle: '左移栅格数',
      colPushTitle: '右移栅格数',
      colSpanTitle: '栅格宽度',
      colorStyle: '主题颜色',
      colsOfGrid: '当前栅格列:',
      columnSetting: '栅格属性设置',
      commonSetting: '常见属性',
      contentPosition: '文字位置',
      controlsPosition: '控制按钮位置',
      customClass: '自定义CSS样式',
      customLabelIcon: '定制字段标签',
      dashed: '显示虚线',
      dataSetEnabled: '开启多数据集返回',
      dataSetName: '指定数据集',
      dataSetRemarkInputPlaceholder: '备注说明',
      dataSetSetting: '返回数据集管理',
      dataSetSettingTitle: '4. 多数据集配置',
      dataSource: '数据源',
      dataSourceChecked: '选中导出',
      dataSourceSetting: '数据源设置',
      defaultAlign: '默认',
      defaultValue: '默认值',
      deleteDataSourceHint: '确认删除该数据源？',
      deleteEntireCol: '删除整列',
      deleteEntireRow: '删除整行',
      disabled: '禁用',
      displayDirection: '排列方向',
      displayStyle: '显示样式',
      displayType: '显示类型',
      dsConfigHandlerTitle: '1. 请求配置',
      dsDataHandlerTitle: '2. 数据处理',
      dsDescription: '描述信息',
      dsDuplicatedNameError: '数据源名称重复，请修改！',
      dsEnabled: '使用数据源',
      dsErrorHandlerTitle: '3. 错误处理',
      dsName: '指定数据源',
      dsRequestBooleanTypeError: '布尔类型值错误',
      dsRequestData: '发送数据（data）',
      dsRequestHeaders: '请求头（headers）',
      dsRequestMethod: '请求方法',
      dsRequestNameInputPlaceholder: '名称',
      dsRequestNumberTypeError: '数据类型值错误',
      dsRequestParams: '参数（params）',
      dsRequestResult: '返回数据',
      dsRequestTypeInputPlaceholder: '类型',
      dsRequestURL: '请求地址',
      dsRequestURLType: '请求URL类型',
      dsRequestValueBooleanType: '布尔类型',
      dsRequestValueInputPlaceholder: '值',
      dsRequestValueNumberType: '数值类型',
      dsRequestValueStringType: '字符串类型',
      dsRequestValueVariableType: '变量或表达式',
      dsURLStringType: '固定字符串',
      dsURLVariableType: '变量或表达式',
      dsUniqueName: '唯一名称',
      dsValidationError: '数据源设置存在错误，请修改',
      dsvTitle: 'DSV数据源变量',
      editFormEventHandler: '表单事件处理',
      editNameHelp: '修改名称后需按回车确认',
      editWidgetEventHandler: '组件事件处理',
      editable: '可输入',
      endPlaceholder: '截止占位内容',
      eventSetting: '事件属性',
      executeDataSource: '立即执行',
      exportDataSource: '导出数据源',
      fieldValueRequired: '输入内容不可为空',
      fileMaxSize: '文件大小限制(MB)',
      fileTypes: '上传文件类型',
      fileTypesHelp: '支持添加其他文件类型',
      filterable: '可搜索选项',
      fontSize: '字体大小',
      formBackground: '背景色',
      formCss: '表单全局CSS',
      formModelName: '数据对象名称',
      formPadding: '表单内边距',
      formRadius: '圆角',
      formRefName: '引用名称',
      formRulesName: '验证规则名称',
      formSFCSetting: '生成SFC设置',
      formSize: '全局组件大小',
      format: '显示格式',
      globalFunctions: '表单全局函数',
      gridColHeight: '栅格列统一高度(px)',
      gutter: '栅格间隔(px)',
      headers: '上传请求头',
      hidden: '隐藏',
      hiddenHelp: '开启隐藏的字段，同时设置为只读且未设置默认值会导致表单无法提交',
      highThreshold: '高分界限值',
      horizontalDirection: '水平',
      htmlContent: 'HTML',
      icon: '图标',
      iconSize: '图标大小(px)',
      importDataSource: '导入数据源',
      importOptions: '导入选项',
      inactiveColor: '关闭时背景色',
      inactiveText: '关闭时文字描述',
      inactiveValue: '关闭时的值',
      inlineLayout: '行内',
      inputAlign: '输入框对齐',
      inputBorder: '输入框边框',
      inputButton: '输入框按钮设置',
      insertColumnToLeft: '插入左侧列',
      insertColumnToRight: '插入右侧列',
      insertRowAbove: '插入上方行',
      insertRowBelow: '插入下方行',
      inset: '卡片样式',
      label: '标签',
      labelAlign: '标签对齐',
      labelHidden: '隐藏字段标签',
      labelIconClass: '标签Icon样式',
      labelIconPosition: '标签Icon位置',
      labelKeyName: '选项标签名',
      labelPosition: '字段标签位置',
      labelTooltip: '标签文字提示',
      labelWidth: '标签宽度',
      leftAlign: '居左',
      leftIcon: '左侧Icon',
      leftPosition: '左边',
      limit: '最大上传数量',
      lowThreshold: '低分界限值',
      maxDate: '最大日期',
      maxLength: '最大长度',
      maxStars: '最大评分值',
      maxValue: '最大值',
      mergeEntireColumn: '合并整列',
      mergeEntireRow: '合并整行',
      mergeLeftColumn: '合并左侧单元格',
      mergeRightColumn: '合并右侧单元格',
      mergeRowAbove: '合并上方单元格',
      mergeRowBelow: '合并下方单元格',
      minDate: '最小日期',
      minLength: '最小长度',
      minValue: '最小值',
      multiple: '选项可多选',
      multipleLimit: '多选数量限制',
      multipleSelect: '文件可多选',
      noDataSource: '暂无数据源',
      optionsSetting: '选项设置',
      paneActive: '激活',
      placeholder: '占位内容',
      plain: '朴素按钮',
      popupZIndex: '弹出窗口层级',
      precision: '精度',
      previewDataSourceExportResult: '导出结果预览',
      range: '是否为范围选择',
      readonly: '只读',
      remainExistingDataSource: '追加到已有数据源之后',
      remote: '可远程搜索',
      required: '必填字段',
      requiredHint: '必填校验提示',
      resetDefault: '重设选中项',
      responsive: '响应式布局',
      rightAlign: '居右',
      rightIcon: '右侧Icon',
      round: '圆角按钮',
      rows: '行数',
      saveDataSource: '保存数据源',
      selectDataSourceForExport: '选择导出数据源',
      shape: '形状',
      shapeRound: '圆形',
      shapeSquare: '方形',
      showBlankRow: '默认显示新行',
      showFileList: '显示文件列表',
      showPassword: '可显示密码',
      showRowNumber: '显示行号',
      showScore: '显示当前分数',
      showStops: '显示间断点',
      showText: '显示辅助文字',
      showWordLimit: '显示字数统计',
      startPlaceholder: '起始占位内容',
      step: '增减步长',
      stepButtonSize: '步进按钮大小(px)',
      switchSize: '开关尺寸（px）',
      syntaxCheckWarning: 'JS代码存在语法错误，请仔细检查！',
      tabPaneSetting: '选项卡设置',
      testDataSource: '测试数据源',
      textContent: '静态文字',
      textEllipsis: '省略过长标题',
      topPosition: '顶部',
      undoMergeCol: '撤销列合并',
      undoMergeRow: '撤销行合并',
      uniqueName: '唯一名称',
      uploadButtonText: '上传按钮文字',
      uploadPictureCapture: '图片选取类型',
      uploadPictureCaptureAlbum: '从相册选择',
      uploadPictureCaptureAlbumTip: '从相册选择仅uniapp渲染器的微信和APP支持',
      uploadPictureCaptureAll: '不限',
      uploadPictureCaptureCamera: '拍照上传',
      uploadSetting: '上传参数设置',
      uploadTip: '上传提示内容',
      uploadURL: '上传地址',
      validation: '字段校验',
      validationHelp: '支持输入正则表达式',
      validationHint: '校验失败提示',
      valueFormat: '绑定值格式',
      valueKeyName: '选项值名',
      vertical: '是否竖向显示',
      verticalDirection: '垂直',
      widgetColumnWidth: '组件列宽',
      widgetName: '组件唯一名称',
      widgetSize: '组件大小',
      withCredentials: '发送cookie凭证',
    },

    toolbar: {
      clear: '清空',
      exportCode: '导出代码',
      exportJson: '导出JSON',
      generateCode: '生成代码',
      importJson: '导入JSON',
      mobileLayout: 'H5',
      nodeTreeHint: '组件层次结构树',
      nodeTreeTitle: '组件层次结构树',
      padLayout: 'Pad',
      pcLayout: 'PC',
      preview: '预览',
      redoHint: '重做',
      undoHint: '撤销',
    },

    widgetLabel: {
      custom: 'Custom Component',
      'm-button': '按钮',
      'm-calendar': '日历',
      'm-cascader': '级联选择',
      'm-cell-group': '分组',
      'm-checkbox': '多选项',
      // 'time-range':       '时间范围',
      'm-date': '日期',
      'm-date-range': '日期范围',

      'm-datetime': '日期时间',
      'm-divider': '分隔线',
      'm-file-upload': '文件',
      'm-grid': '栅格',
      'm-grid-col': '栅格列',
      'm-html-text': 'HTML',
      // 'data-table':     '数据表格',
      'm-input': '单行输入',
      'm-number': '数字输入',
      'm-password': '密码输入',
      'm-picture-upload': '图片',
      'm-radio': '单选项',
      'm-rate': '评分',
      'm-rich-editor': '富文本',
      'm-select': '选择器',
      // color:          '颜色选择器',
      'm-slider': '滑块',
      'm-slot': '插槽',
      'm-static-text': '静态文字',
      'm-stepper': '步进输入',
      'm-sub-form': '子表单',
      'm-switch': '开关',
      // table:            '表格',

      'm-tab': '标签页',
      'm-textarea': '多行输入',
      'm-time': '时间',
      // section:          '区块',
      'sub-form': '子表单',
      'tab-pane': '选项卡页',

      'table-cell': '单元格',
    },
  },
};
